import React from 'react';
import * as Styled from './PageWrapper.styles';

const PageWrapper = ({ children }) => (
  <Styled.PageWrapper>{children}</Styled.PageWrapper>
);

export default PageWrapper;
